<template>
  <div></div>
</template>

<script>
export default {
  name: 'mixa-onload-tagging',
  props: {
    productName: {
      type: String,
      required: true,
    },
    productSku: {
      type: String,
      required: true,
    },
    productBrand: {
      type: String,
      required: true,
    },
    productCategory: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  created() {
    this.getTagging();

    window.eventBus.$on('TabEventDataLayer', (value) => {
      this.TabEventDataLayer(value);
    });

    window.eventBus.$on('store-item-datalayer', (value) => {
      this.storeItemTagging(value);
    });

    window.eventBus.$on('productDataLayer', (value) => {
      this.productDataLayer(value);
    });
  },
  methods: {
    getTagging() {
      dataLayer.push({
        event: 'nievent',
        eventCategory: 'Ecommerce',
        eventAction: 'Product Detail',
        eventLabel: `${this.productName}::${this.productSku}`,
        event_name: 'view_item',
        product_info: `${this.productName}::${this.productSku}`,
        ecommerce: {
          detail: {
            products: {
              name: this.productName,
              id: this.productSku,
              brand: this.productBrand,
              category: this.productCategory,
              dimension48: this.productSku,
            },
          },
        },
      });
    },
    storeItemTagging(value) {
      dataLayer.push({
        event: 'addToCart',
        eventCategory: 'Ecommerce',
        eventAction: 'redirection::' + value,
        eventLabel: `${this.productName}::${this.productSku}`,
        ecommerce: {
          add: {
            products: {
              name: this.productName,
              id: this.productSku,
              brand: 'MIX',
              category: this.productCategory,
              dimension48: `${this.productName}::${this.productSku}`,
            },
          },
        },
        event_name: 'add_to_cart',
        product_info: `${this.productName}::${this.productSku}`,
        step: 'redirection',
        store_name: value,
      });
    },
    TabEventDataLayer(val) {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'product detail page',
        eventAction: `select::${val}`,
        eventLabel: `${this.productName}::${this.productSku}`,
        ecommerce: undefined,
        event_name: 'product_info_click',
        product_tab: val,
        product_info: `${this.productName}::${this.productSku}`,
      });
    },
  },
};
</script>
